import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import App from './App.vue'
import { i18n } from './shared/i18n'
import { router } from './router'
import './shared/styles/tokens.css'
import './shared/styles/base.css'

createApp(App).use(createPinia()).use(i18n).use(router).use(ElementPlus, { locale: zhCn }).mount('#app')
